import { ChartLegendItem } from "../../views/pages/modules/mep/common-vm/chart-legend-view-model"

export const Urls = {
    GetMepPorts: "Mep/GetMepPorts",
    GetVesselTypeGroups: "Mep/GetVesselTypeGroups",
    GetVesselTypeGroupsForPortHome: "Mep/GetVesselTypeGroupsForPortHome",
    GetVesselTypeGroupsForPortDashboard: "Mep/GetVesselTypeGroupsForPortDashboard",
    GetMepPortDetails: "Mep/GetMepPortDetails",
    GetMepDashboardSummaryForPortDashboard: "Mep/GetMepDashboardSummaryForPortDashboard",
    GetMepVesselStatistics: "Mep/GetMepVesselStatistics",
    GetMepTopVesselsEmissionsPerformers: "Mep/GetMepTopVesselsEmissionsPerformers",
    GetMepEmissionsByMonth: "Mep/GetMepEmissionsByMonth",
    GetMepEmissionsBySomeType: "Mep/GetMepEmissionsBySomeType",
    GetMepEmissionsAdditionalDetails: "Mep/GetMepEmissionsAdditionalDetails",
    GetMepEmissionsAdditionalDetailsForPortDashboard: "Mep/GetMepEmissionsAdditionalDetailsForPortDashboard",
    GetLatestFinancialYear: "Mep/GetLatestFinancialYear",
    GetMepDashboardVesselTypeDistribution: "Mep/GetMepDashboardVesselTypeDistribution",
    GetMepDashboardPointsOfInterestHeatmap: "Mep/GetMepDashboardPointsOfInterestHeatmap",
    UploadMepVesselPortActivities: "Mep/UploadMepVesselPortActivities",
    UpdateCargoData: "Mep/UpdateCargoData",
    DownloadMepVessel: "Mep/DownloadMepVessel",
    DownloadMepVesselPortActivitiesTemplate: "Mep/DownloadMepVesselPortActivitiesTemplate",
    GetMepCustomers: "Mep/GetMepCustomers",
    GetMepMonthsList:"Mep/GetMepMonthsList",
    DownloadEmissionsData: "Mep/DownloadEmissionsData",
}

export const MepChartColors: string[] = ["#1A8574",
"#003745",
"#007991",
"#f7661f",
"#D71920",
"#808184"]

export const MepEmissionTypeColors: ChartLegendItem[] = [
{ id: 1, name: "(CH3)2C6H4",color: "#007991" },
{ id: 2, name:	"NOX", color: "#4C4C4C" },
{ id: 3, name:	"CO", color: "#8225AD" },
{ id: 4, name:	"PM10", color: "#CA4F00" },
{ id: 5, name:	"VOCs", color: "#0C3C34" },
{ id: 6, name:	"CO2", color: "#008561" },
{ id: 7, name:	"C6H5CH2CH3", color: "#002957" },
{ id: 8, name:	"C7H8", color: "#F54D58" },
{ id: 9, name:	"PM2.5", color: "#FFE150" },
{ id: 10, name:	"PAHs", color: "#6E0C14" },
{ id: 11, name:	"SOX", color: "#2E9DFF" },
{ id: 12, name:	"C6H6", color: "#CCE4E9" },
{ id: 13, name:	"CH2O", color: "#B0B4BF" },
{ id: 14, name:	"C12H4Cl4O2", color: "#581975" }
]

export const MepVesselTypeColors: ChartLegendItem[] = [
    { id:1, name: "Bulk Carriers", color:"#0C3C34" },
    { id:2, name: "General Cargo", color:"#2E9DFF" },
    { id:3, name: "LNG Tankers", color:"#8225AD" },
    { id:4, name: "LPG/Anhydrous ammonia tankers", color:"#CA4F00" },
    { id:5, name: "Offshore support vessels", color:"#CCE4E9" },
    { id:6, name: "Other", color:"#002957" },
    { id:7, name: "Product Tanker", color:"#007991" },
    { id:8, name: "Tugboats", color:"#581975" },
    { id:9, name: "Bulk Carriers", color:"#0C3C34" },
    { id:10, name: "General Cargo", color:"#2E9DFF" },
    { id:11, name: "Offshore support vessels", color:"#CCE4E9" },
    { id:12, name: "Other", color:"#002957" },
    { id:13, name: "Product Tanker", color:"#007991" },
    { id:14, name: "Tugboats", color:"#581975" },
    { id:15, name: "Bulk Carriers", color:"#0C3C34" },
    { id:16, name: "General Cargo", color:"#2E9DFF" },
    { id:17, name: "LNG Tankers", color:"#8225AD" },
    { id:18, name: "Offshore support vessels", color:"#CCE4E9" },
    { id:19, name: "Other", color:"#002957" },
    { id:20, name: "Product Tankers", color:"#007991" },
    { id:21, name: "Tugboats", color:"#581975" },
    { id:22, name: "Auto carriers", color:"#4C4C4C" },
    { id:23, name: "Bulk Carriers", color:"#0C3C34" },
    { id:24, name: "General Cargos", color:"#2E9DFF" },
    { id:25, name: "Offshore support vessels", color:"#CCE4E9" },
    { id:26, name: "Other", color:"#002957" },
    { id:27, name: "RoRos", color:"#FFE150" },
    { id:28, name: "Product Tanker", color:"#007991" },
    { id:29, name: "Tugboats", color:"#581975" },
]

export const MepOperationModeColors: ChartLegendItem[] = [
    { id: 1, name:	"Manoeuvre", color: "#CCE4E9" },
    { id: 2, name: "Anchor",color: "#0C3C34" },
    { id: 3, name:	"Alongside", color: "#007991" },
    { id: 4, name:	"Transit", color: "#581975" }
]

export enum MepEmissionsTargetColourEnum {
    Low = 1,
    Medium = 2,
    High = 3
}

export const MepLowTargetColor: string = "#62BA46";
export const MepMediumTargetColor: string = "#FFAA1C";
export const MepHighTargetColor: string = "#D71920";